/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".imageUrl[_ngcontent-%COMP%]{height:auto;width:100vw;margin:0 auto}.error[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:30px;height:100vh}\n/*# sourceMappingURL=generic-webview.component.css.map*/"];
export { styles as styles };
